import { atBqnTarget } from "common/api";

const warningRE = new RegExp("%WARN-EINVAL:\\s(.*)");
export const handleWarnings = (input) => {
  const match = input.match(warningRE);
  if (match !== null) {
    const [_all, message] = match;
    throw message;
  }
  return input;
};


// The policies of the BQN selected in the header, or of the whole cluster,
// asked together with the running configuration, which is the one of the
// cluster and takes no BQN of its own.
export const policiesBatchCommand = (mode, bqnId) =>
  `${[
    atBqnTarget("show policy monitor statistics web", mode, bqnId),
    "show config running all",
  ].join("\n")}\n`;
